module.exports = __webpack_public_path__ + "static/media/sura-star-icon.23acfb68.svg";